import './instrument';

// Modules
import ReactDOM from 'react-dom/client';
import i18next from "i18next";
import { I18nextProvider } from 'react-i18next';

// Components
import App from './App';
import reportWebVitals from './reportWebVitals';

// Translations
import { translations } from './translations';
import { ElectronProvider } from './context/ElectronContext';

// Service Worker Registration
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// init translations
i18next.init(translations);

// Create root element
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Render Sippar
root.render(
  <I18nextProvider i18n={i18next}>
    <ElectronProvider>
      <App />
    </ElectronProvider>
  </I18nextProvider>
);

// Registrar Service Worker para caché offline y resiliencia en redes lentas
serviceWorkerRegistration.register({
  onSuccess: () => console.log('[Sippar] Contenido cacheado para uso offline'),
  onUpdate: (registration) => {
    console.log('[Sippar] Nueva versión disponible');
    // Activar el nuevo SW inmediatamente
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  },
});

reportWebVitals();
